import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HiddenMessage = ({
  title,
  body = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.common-message.hiddenMessage.body"
  }),
  tooltip
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "info",
    titleText: title,
    children: [body, tooltip && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1",
      title: tooltip
    })]
  });
};
HiddenMessage.displayName = 'HiddenMessage';
export default HiddenMessage;